import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import LoadingIcon from "../../images/Loading_icon.gif";
import Swal from "sweetalert2";
import { UrlContext } from "../../contexts/UrlContext";

export default function ExCreateDigitalPPT({
  digitalExist,
  pptExist,
  expert_id,
  project_id,
  project,
  expertName,
  digitalPowerPointList,
  titleCount,
  setTitleCount,
}) {
  const { API_URL } = useContext(UrlContext);
  const [digitalProfile, setDigitalProfile] = useState(false);
  const [pptExistingPopup, setPptExistingPopup] = useState(false);
  const [noExistDimension, setNoExistDimension] = useState(false);
  const [afterExistDimension, setAfterExistDimension] = useState(false);
  const [createdPPTList, setCreatedPPTList] = useState(null);
  const [digitalPPTList, setDigitalPPTList] = useState(null);
  const [waitingPopup, setWaitingPopup] = useState(false);
  const [exprj_id, setExprj_id] = useState(null);
  const [loadingPopup, setLoadingPopup] = useState(false);
  const [dimensions, setDimensions] = useState({
    dimension1: "",
    dimension2: "",
    dimension3: "",
    dimension4: "",
    dimension5: "",
  });
  const [isClicked, setIsClicked] = useState(false);

  const fetchData = async () => {
    try {
      const response = await fetch(
        `${API_URL}expert-existing-ppt-for-list/${expert_id}/${project_id}`
      );

      if (!response.ok) {
        throw new Error(`Request failed with status: ${response.status}`);
      }

      const data = await response.json();
      setCreatedPPTList(data.pEx_expert);
      setDigitalPPTList(data.digitalPowerPoint);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (isClicked) {
      fetchData();
    }
  }, [isClicked]);

  useEffect(() => {
    if (digitalExist) {
      setDigitalProfile(true);
    }
    setDimensions({
      dimension1: project["dimension1"],
      dimension2: project["dimension2"],
      dimension3: project["dimension3"],
      dimension4: project["dimension4"],
      dimension5: project["dimension5"],
    });
  }, [digitalExist, project]);

  const saveDimensionsHandler = (e) => {
    setPptExistingPopup(false);
    setNoExistDimension(false);
    setAfterExistDimension(false);
    e.preventDefault();
    const url = `${API_URL}save-project-dimensions/` + project_id;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dimensions),
    })
      .then((res) => res.json())
      .then((data) => {
        setNoExistDimension(false);
        setDigitalProfile(true);
        setTitleCount(titleCount + 1);
        window.open(
          `/app/PreviewDigitalPPTForList/${project_id}/${expert_id}/${exprj_id}`,
          "_blank"
        );
      })
      .catch((err) => console.log(err));
  };

  // const existingPPTHandler = (projectID, pptName) => {
  //   setPptExistingPopup(false);
  //   setWaitingPopup(true);
  //   const url = `${API_URL}download-existingPPT-for-list`;
  //   const data = {
  //     expertName: expertName.toString(),
  //     expertID: expert_id.toString(),
  //     projectID: projectID.toString(),
  //     currentProjectID: project_id.toString(),
  //     pptName: pptName.toString(),
  //   };
  //   fetch(url, {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(data),
  //   })
  //     .then((res) => res.json())
  //     .then((data) => {
  //       if (data.message === "downloaded") {
  //         setWaitingPopup(false);
  //         setDigitalProfile(true);
  //       } else if (data.message === null) {
  //         setWaitingPopup(false);
  //         Swal.fire({
  //           title: "Error!",
  //           text: "PPT not found",
  //           icon: "error",
  //           confirmButtonText: "OK",
  //         });
  //       } else {
  //         setWaitingPopup(false);
  //         Swal.fire({
  //           title: "Error!",
  //           text: "Something went wrong",
  //           icon: "error",
  //           confirmButtonText: "OK",
  //         });
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       setWaitingPopup(false);
  //       Swal.fire({
  //         title: "Error!",
  //         text: "Something went wrong",
  //         icon: "error",
  //       });
  //     });
  // };
  const existingPPTHandler = (projectID, pptName) => {
    setPptExistingPopup(false);
    setWaitingPopup(true);
    const authToken = localStorage.getItem("accesstoken");
    const url = `${API_URL}download-existingPPT-for-list`;
    const data = {
      expertID: expert_id.toString(),
      projectID: projectID.toString(),
      currentProjectID: project_id.toString(),
      pptName: pptName.toString(),
      authToken: authToken,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.message) {
          setWaitingPopup(false);
          Swal.fire({
            title: "Warning!",
            text: `File already exist`,
            icon: "warning",
            confirmButtonText: "OK",
          });
        }
        // if (!data.digitalPptUrl || !data.newPptUrl) {
        if (!data.newPptUrl) {
          setWaitingPopup(false);
          Swal.fire({
            title: "Error!",
            text: `Something Went Wrong`,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
        setWaitingPopup(false);
        // window.open(data.digitalPptUrl, "_blank", "rel=noopener noreferrer");
        window.open(data.newPptUrl, "_blank", "rel=noopener noreferrer");
      })
      .catch((err) => {
        console.log(err);
        setWaitingPopup(false);
        Swal.fire({
          title: "Error!",
          text: "Something went wrong",
          icon: "error",
        });
      });
  };

  // Api to create new digital profile
  const createDigitalProfile = async () => {
    setLoadingPopup(true);
    const requestBody = {
      projectID: project_id,
      expertID: expert_id
    };
    try {
      let modifiedUrl = "create-digital-profile-for-list";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        setDigitalProfile(true);
        setLoadingPopup(false);
        Swal.fire({
          title: "Success",
          text: responseData.text,
          icon: "success",
          confirmButtonText: "OK",
        });
        window.open(
          `/app/PreviewDigitalPPTForList/${project_id}/${expert_id}/${exprj_id}`,
          "_blank"
        );
      } else {
        console.error("Failed to get language");
        setLoadingPopup(false);
        Swal.fire({
          title: "Error!",
          text: responseData.text,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
      setLoadingPopup(false);
      Swal.fire({
        title: "Error!",
        text: "Failed to fetch existing powerpoints!",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };
  
  // Api to create new digital profile from existing digital profile
  const createDigitalProfileFromExistingDigital = async (existingProjectID) => {
    setLoadingPopup(true);
    const requestBody = {
      existingProjectID: existingProjectID,
      currentProjectID: project_id,
      expertID: expert_id
    };
    try {
      let modifiedUrl = "create-digital-profile-from-existing-digital-for-list";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        setDigitalProfile(true);
        setLoadingPopup(false);
        Swal.fire({
          title: "Success",
          text: responseData.text,
          icon: "success",
          confirmButtonText: "OK",
        });
        window.open(
          `/app/PreviewDigitalPPTForList/${project_id}/${expert_id}/${exprj_id}`,
          "_blank"
        );
      } else if (responseData.status==='error') {
        console.error("Failed to get language");
        setLoadingPopup(false);
        Swal.fire({
          title: "Error!",
          text: responseData.text,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
      setLoadingPopup(false);
      Swal.fire({
        title: "Error!",
        text: "Failed to fetch existing powerpoints!",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };
  
  // Api to create new powerpoint from existing physical
  const createDigitalProfileFromExistingPhysical = async () => {
    setLoadingPopup(true);
    const requestBody = {
      projectID: project_id,
      expertID: expert_id
    };
    try {
      let modifiedUrl = "create-digital-profile-from-existing-physical-for-list";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        setDigitalProfile(true);
        setLoadingPopup(false);
        Swal.fire({
          title: "Success",
          text: responseData.text,
          icon: "success",
          confirmButtonText: "OK",
        });
        window.open(
          `/app/PreviewDigitalPPTForList/${project_id}/${expert_id}/${exprj_id}`,
          "_blank"
        );
      } else if (responseData.status==='error') {
        console.error("Failed to get language");
        setLoadingPopup(false);
        Swal.fire({
          title: "Error!",
          text: responseData.text,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
      setLoadingPopup(false);
      Swal.fire({
        title: "Error!",
        text: "Failed to fetch existing powerpoints!",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const existingDigitalPPTHandler = async (exprj_id) => {
    setPptExistingPopup(false);
    await createDigitalProfileFromExistingDigital(exprj_id);
  };

  const createProfileHandler = async () => {
    if (pptExist) {
      setIsClicked(true);
      setPptExistingPopup(true);
    } else {
      if (dimensions.dimension1 === "" || dimensions.dimension1 === null) {
        setNoExistDimension(true);
      } else {
        await createDigitalProfile();
        // window.open(
        //   `/app/PreviewDigitalPPTForList/${project_id}/${expert_id}/${exprj_id}`,
        //   "_blank"
        // );
        // setDigitalProfile(true);
      }
    }
  };

  const createNewPPTHandler = async () => {
    if (dimensions.dimension1 === "" || dimensions.dimension1 === null) {
      setAfterExistDimension(true);
    } else {
      setPptExistingPopup(false);
      await createDigitalProfile();
    }
  };

  useEffect(() => {
    if (digitalPowerPointList) {
      setDigitalPPTList(digitalPowerPointList);
    }
  }, [digitalPowerPointList]);

  return (
    <>
      {digitalProfile ? (
        <Link
          to={`/app/PreviewDigitalPPTForList/${project_id}/${expert_id}/${exprj_id}`}
          target="_blank"
          rel="noreferrer"
        >
          <button className="btn">Modify Profile</button>
        </Link>
      ) : (
        <button className="btn" onClick={createProfileHandler}>
          Create Profile
        </button>
      )}

      {pptExistingPopup && pptExist && (
        <div id="pptExisting-wrapper">
          <div className="tab-pane fade show pptExisting-div position-relative">
            <i
              className="pptlist-close-icon fa-regular fa-rectangle-xmark"
              onClick={() => setPptExistingPopup(false)}
            ></i>
            <h5 className="mb-3" style={{ textAlign: "center" }}>
              PPT for the chosen profile already exists. Would you like to use
              any one of them?
            </h5>

            {digitalPPTList?.length > 0 && (
              <div className="row" style={{ marginBottom: "10px" }}>
                <div className="col-md-12">
                  <table className="expert-pptExists-table">
                    <thead>
                      <tr>
                        <th style={{ minWidth: "800px", width: "900px" }}>
                          Existing Digital PPTs
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {digitalPPTList?.map((project) => {
                        if (project.digitalPowerPointName) {
                          return (
                            <tr key={project.projectID}>
                              <td
                                onClick={() =>
                                  existingDigitalPPTHandler(project.projectID)
                                }
                                style={{ cursor: "pointer" }}
                              >
                                <div className="expert-ppt-existing-row">
                                  {project.digitalPowerPointName}
                                </div>
                              </td>
                            </tr>
                          );
                        } else return null;
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {createdPPTList?.length > 0 && (
              <div className="row">
                <div className="col-md-12">
                  <table className="expert-pptExists-table">
                    <thead>
                      <tr>
                        <th style={{ minWidth: "800px", width: "900px" }}>
                          Existing Physical PPTs
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {createdPPTList?.map((project) => {
                        if (project.pptExist) {
                          return (
                            <tr key={project.project_id}>
                              <td
                                onClick={() => {
                                  existingPPTHandler(
                                    project.project_id,
                                    project.pptExist
                                  );
                                  createDigitalProfileFromExistingPhysical()
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <div className="expert-ppt-existing-row">
                                  {project.pptExist}
                                  <button className="btn-default PPT_Exist" />
                                </div>
                              </td>
                            </tr>
                          );
                        } else return null;
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
            <div style={{ marginTop: 20, textAlign: "center" }}>
              <button
                type="button"
                className="btn btn-light"
                onClick={() => setPptExistingPopup(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn base-btn"
                onClick={createNewPPTHandler}
              >
                Create New PPT
              </button>
            </div>
          </div>
        </div>
      )}

      {noExistDimension && !pptExist && (
        <div id="pptEnDi-wrapper">
          <form onSubmit={saveDimensionsHandler}>
            <div className="tab-pane fade show pptEnDi-div">
              <h3 className="mb-3" style={{ textAlign: "center" }}>
                Enter Dimensions
              </h3>
              <div className="row">
                <div
                  className="col-md-12"
                  style={{ paddingLeft: 20, paddingRight: 20 }}
                >
                  <div className="form-group">
                    <label>Dimension 1</label>
                    <input
                      className="form-control"
                      value={dimensions.dimension1}
                      onChange={(e) =>
                        setDimensions({
                          ...dimensions,
                          dimension1: e.target.value,
                        })
                      }
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Dimension 2</label>
                    <input
                      className="form-control"
                      value={dimensions.dimension2}
                      onChange={(e) =>
                        setDimensions({
                          ...dimensions,
                          dimension2: e.target.value,
                        })
                      }
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Dimension 3</label>
                    <input
                      className="form-control"
                      value={dimensions.dimension3}
                      onChange={(e) =>
                        setDimensions({
                          ...dimensions,
                          dimension3: e.target.value,
                        })
                      }
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Dimension 4</label>
                    <input
                      className="form-control"
                      value={dimensions.dimension4}
                      onChange={(e) =>
                        setDimensions({
                          ...dimensions,
                          dimension4: e.target.value,
                        })
                      }
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Dimension 5</label>
                    <input
                      className="form-control"
                      value={dimensions.dimension5}
                      onChange={(e) =>
                        setDimensions({
                          ...dimensions,
                          dimension5: e.target.value,
                        })
                      }
                      required
                    />
                  </div>
                </div>
              </div>
              <div style={{ textAlign: "center" }}>
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => setNoExistDimension(false)}
                >
                  Cancel
                </button>
                <button type="submit" className="btn base-btn">
                  Create New PPT
                </button>
              </div>
            </div>
          </form>
        </div>
      )}

      {afterExistDimension && (
        <div id="pptEnDi-wrapper">
          <form onSubmit={saveDimensionsHandler}>
            <div className="tab-pane fade show pptEnDi-div">
              <h3 className="mb-3" style={{ textAlign: "center" }}>
                Enter Dimensions
              </h3>
              <div className="row">
                <div
                  className="col-md-12"
                  style={{ paddingLeft: 20, paddingRight: 20 }}
                >
                  <div className="form-group">
                    <label>Dimension 1</label>
                    <input
                      className="form-control"
                      value={dimensions.dimension1}
                      onChange={(e) =>
                        setDimensions({
                          ...dimensions,
                          dimension1: e.target.value,
                        })
                      }
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Dimension 2</label>
                    <input
                      className="form-control"
                      value={dimensions.dimension2}
                      onChange={(e) =>
                        setDimensions({
                          ...dimensions,
                          dimension2: e.target.value,
                        })
                      }
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Dimension 3</label>
                    <input
                      className="form-control"
                      value={dimensions.dimension3}
                      onChange={(e) =>
                        setDimensions({
                          ...dimensions,
                          dimension3: e.target.value,
                        })
                      }
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Dimension 4</label>
                    <input
                      className="form-control"
                      value={dimensions.dimension4}
                      onChange={(e) =>
                        setDimensions({
                          ...dimensions,
                          dimension4: e.target.value,
                        })
                      }
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Dimension 5</label>
                    <input
                      className="form-control"
                      value={dimensions.dimension5}
                      onChange={(e) =>
                        setDimensions({
                          ...dimensions,
                          dimension5: e.target.value,
                        })
                      }
                      required
                    />
                  </div>
                </div>
              </div>
              <div style={{ textAlign: "center" }}>
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => setAfterExistDimension(false)}
                >
                  Cancel
                </button>
                <button type="submit" className="btn base-btn">
                  Create New PPT
                </button>
              </div>
            </div>
          </form>
        </div>
      )}

      {waitingPopup && (
        <div className="downloadPPT-popup-wrapper">
          <div className="tab-pane fade show downloadPPT-div">
            <center>
              <p style={{ fontSize: "18px" }}>Existing PPT is downloading..</p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}
    </>
  );
}
